import { render, staticRenderFns } from "./AddLeaguePricekinetic.vue?vue&type=template&id=7c3c6c96&scoped=true&"
import script from "./AddLeaguePricekinetic.vue?vue&type=script&lang=js&"
export * from "./AddLeaguePricekinetic.vue?vue&type=script&lang=js&"
import style0 from "./AddLeaguePricekinetic.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddLeaguePricekinetic.vue?vue&type=style&index=1&id=7c3c6c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3c6c96",
  null
  
)

export default component.exports